import { Fragment } from 'react';

import InputText, { InputType } from 'bloko/blocks/inputText';
import Textarea from 'bloko/blocks/textarea';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setCrmActivityDescription, setCrmActivityLimit, setCrmActivityTitle } from 'store/models/crmActivity';
import { useDispatch, useSelector } from 'store/utils';

const CrmActivityForm = () => {
    const dispatch = useDispatch();
    const { title, description, dailyLimit } = useSelector((state) => state.crmActivity);
    const trl = useTrls();

    return (
        <Fragment>
            <ClickmeFormItem
                input={<InputText value={title} onChange={(value) => dispatch(setCrmActivityTitle(value))} />}
                legend={trl('Admin.CrmActivity.Form.Title.legend')}
                hint={trl('Admin.CrmActivity.Form.Title.hint')}
                isRequired
            />
            <ClickmeFormItem
                input={
                    <Textarea
                        value={description}
                        onChange={(event) => dispatch(setCrmActivityDescription(event.target.value))}
                        rows={12}
                        noresize
                    />
                }
                legend={trl('Admin.CrmActivity.Form.Description.legend')}
                hint={trl('Admin.CrmActivity.Form.Description.hint')}
                isRequired
            />
            <ClickmeFormItem
                input={
                    <InputText
                        type={InputType.Number}
                        value={dailyLimit}
                        onChange={(value) => dispatch(setCrmActivityLimit(value))}
                    />
                }
                legend={trl('Admin.CrmActivity.Form.Limit.legend')}
                hint={trl('Admin.CrmActivity.Form.Limit.hint')}
            />
        </Fragment>
    );
};

export default CrmActivityForm;
